@file:OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)

package limasoul.client.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.StringResource

private object CommonMainString0 {
  public val admin_screen_songs_item_title: StringResource by 
      lazy { init_admin_screen_songs_item_title() }

  public val admin_screen_title: StringResource by 
      lazy { init_admin_screen_title() }

  public val admin_screen_users_item_title: StringResource by 
      lazy { init_admin_screen_users_item_title() }

  public val common_close_button: StringResource by 
      lazy { init_common_close_button() }

  public val create_event_track_screen_add_button: StringResource by 
      lazy { init_create_event_track_screen_add_button() }

  public val create_event_track_screen_additional: StringResource by 
      lazy { init_create_event_track_screen_additional() }

  public val create_event_track_screen_artist: StringResource by 
      lazy { init_create_event_track_screen_artist() }

  public val create_event_track_screen_comment: StringResource by 
      lazy { init_create_event_track_screen_comment() }

  public val create_event_track_screen_members: StringResource by 
      lazy { init_create_event_track_screen_members() }

  public val create_event_track_screen_select_track: StringResource by 
      lazy { init_create_event_track_screen_select_track() }

  public val create_event_track_screen_title: StringResource by 
      lazy { init_create_event_track_screen_title() }

  public val create_event_track_screen_track: StringResource by 
      lazy { init_create_event_track_screen_track() }

  public val dialog_cancel: StringResource by 
      lazy { init_dialog_cancel() }

  public val dialog_ok: StringResource by 
      lazy { init_dialog_ok() }

  public val error_dialog_ok: StringResource by 
      lazy { init_error_dialog_ok() }

  public val error_dialog_title: StringResource by 
      lazy { init_error_dialog_title() }

  public val event_create_applies: StringResource by 
      lazy { init_event_create_applies() }

  public val event_create_button: StringResource by 
      lazy { init_event_create_button() }

  public val event_create_card_background: StringResource by 
      lazy { init_event_create_card_background() }

  public val event_create_date: StringResource by 
      lazy { init_event_create_date() }

  public val event_create_description: StringResource by 
      lazy { init_event_create_description() }

  public val event_create_genre: StringResource by 
      lazy { init_event_create_genre() }

  public val event_create_limits: StringResource by 
      lazy { init_event_create_limits() }

  public val event_create_map_link: StringResource by 
      lazy { init_event_create_map_link() }

  public val event_create_members: StringResource by 
      lazy { init_event_create_members() }

  public val event_create_screen_title: StringResource by 
      lazy { init_event_create_screen_title() }

  public val event_create_songs_count: StringResource by 
      lazy { init_event_create_songs_count() }

  public val event_create_spot: StringResource by 
      lazy { init_event_create_spot() }

  public val event_create_title: StringResource by 
      lazy { init_event_create_title() }

  public val event_detail_confirm_member_cancellation_message: StringResource by 
      lazy { init_event_detail_confirm_member_cancellation_message() }

  public val event_detail_confirm_member_cancellation_title: StringResource by 
      lazy { init_event_detail_confirm_member_cancellation_title() }

  public val event_detail_confirm_member_message: StringResource by 
      lazy { init_event_detail_confirm_member_message() }

  public val event_detail_confirm_member_title: StringResource by 
      lazy { init_event_detail_confirm_member_title() }

  public val event_detail_screen_acceptance_optional: StringResource by 
      lazy { init_event_detail_screen_acceptance_optional() }

  public val event_detail_screen_acceptance_title: StringResource by 
      lazy { init_event_detail_screen_acceptance_title() }

  public val event_detail_screen_menu_edit: StringResource by 
      lazy { init_event_detail_screen_menu_edit() }

  public val event_detail_screen_menu_set_list: StringResource by 
      lazy { init_event_detail_screen_menu_set_list() }

  public val event_detail_screen_optional_warning: StringResource by 
      lazy { init_event_detail_screen_optional_warning() }

  public val event_detail_screen_title: StringResource by 
      lazy { init_event_detail_screen_title() }

  public val event_detail_screen_track_artist_and_track: StringResource by 
      lazy { init_event_detail_screen_track_artist_and_track() }

  public val event_edit_screen_delete_button: StringResource by 
      lazy { init_event_edit_screen_delete_button() }

  public val event_edit_screen_delete_confirmation_message: StringResource by 
      lazy { init_event_edit_screen_delete_confirmation_message() }

  public val event_edit_screen_delete_confirmation_title: StringResource by 
      lazy { init_event_edit_screen_delete_confirmation_title() }

  public val event_edit_screen_save_button: StringResource by 
      lazy { init_event_edit_screen_save_button() }

  public val event_edit_screen_title: StringResource by 
      lazy { init_event_edit_screen_title() }

  public val event_freeze_screen_backlog_header: StringResource by 
      lazy { init_event_freeze_screen_backlog_header() }

  public val event_freeze_screen_frozen_hint: StringResource by 
      lazy { init_event_freeze_screen_frozen_hint() }

  public val event_freeze_screen_save_button: StringResource by 
      lazy { init_event_freeze_screen_save_button() }

  public val event_freeze_screen_switcher_label: StringResource by 
      lazy { init_event_freeze_screen_switcher_label() }

  public val event_freeze_screen_title: StringResource by 
      lazy { init_event_freeze_screen_title() }

  public val event_list_screen_title: StringResource by 
      lazy { init_event_list_screen_title() }

  public val event_list_screen_tracks: StringResource by 
      lazy { init_event_list_screen_tracks() }

  public val event_member_legend_not_required: StringResource by 
      lazy { init_event_member_legend_not_required() }

  public val event_member_legend_optional: StringResource by 
      lazy { init_event_member_legend_optional() }

  public val event_member_legend_required: StringResource by 
      lazy { init_event_member_legend_required() }

  public val event_member_legend_title: StringResource by 
      lazy { init_event_member_legend_title() }

  public val event_track_details_screen_added_by: StringResource by 
      lazy { init_event_track_details_screen_added_by() }

  public val event_track_details_screen_backlog_header: StringResource by 
      lazy { init_event_track_details_screen_backlog_header() }

  public val event_track_details_screen_delete_button: StringResource by 
      lazy { init_event_track_details_screen_delete_button() }

  public val event_track_details_screen_delete_confirmation_message: StringResource by 
      lazy { init_event_track_details_screen_delete_confirmation_message() }

  public val event_track_details_screen_delete_confirmation_title: StringResource by 
      lazy { init_event_track_details_screen_delete_confirmation_title() }

  public val event_track_details_screen_ready_members: StringResource by 
      lazy { init_event_track_details_screen_ready_members() }

  public val event_track_details_screen_required_members: StringResource by 
      lazy { init_event_track_details_screen_required_members() }

  public val event_track_details_screen_title: StringResource by 
      lazy { init_event_track_details_screen_title() }

  public val login_cannot_find_account: StringResource by 
      lazy { init_login_cannot_find_account() }

  public val login_wanna_join: StringResource by 
      lazy { init_login_wanna_join() }

  public val login_welcome_title: StringResource by 
      lazy { init_login_welcome_title() }

  public val nav_bar_title_admin: StringResource by 
      lazy { init_nav_bar_title_admin() }

  public val nav_bar_title_home: StringResource by 
      lazy { init_nav_bar_title_home() }

  public val nav_bar_title_profile: StringResource by 
      lazy { init_nav_bar_title_profile() }

  public val profile_admin_settings_button: StringResource by 
      lazy { init_profile_admin_settings_button() }

  public val profile_city_placeholder: StringResource by 
      lazy { init_profile_city_placeholder() }

  public val profile_edit: StringResource by 
      lazy { init_profile_edit() }

  public val profile_logout_button: StringResource by 
      lazy { init_profile_logout_button() }

  public val profile_name_placeholder: StringResource by 
      lazy { init_profile_name_placeholder() }

  public val profile_save_button: StringResource by 
      lazy { init_profile_save_button() }

  public val profile_screen_title: StringResource by 
      lazy { init_profile_screen_title() }

  public val profile_telegram_placeholder: StringResource by 
      lazy { init_profile_telegram_placeholder() }

  public val validation_error_date_before_now: StringResource by 
      lazy { init_validation_error_date_before_now() }

  public val validation_error_empty_value: StringResource by 
      lazy { init_validation_error_empty_value() }

  public val validation_error_invalid_date: StringResource by 
      lazy { init_validation_error_invalid_date() }

  public val validation_error_invalid_digit: StringResource by 
      lazy { init_validation_error_invalid_digit() }

  public val validation_error_invalid_symbol: StringResource by 
      lazy { init_validation_error_invalid_symbol() }

  public val validation_error_item_not_selected: StringResource by 
      lazy { init_validation_error_item_not_selected() }

  public val validation_error_items_max_selected: StringResource by 
      lazy { init_validation_error_items_max_selected() }

  public val validation_error_max_int_value: StringResource by 
      lazy { init_validation_error_max_int_value() }

  public val validation_error_max_length: StringResource by 
      lazy { init_validation_error_max_length() }

  public val validation_error_min_int_value: StringResource by 
      lazy { init_validation_error_min_int_value() }

  public val validation_error_must_start_with: StringResource by 
      lazy { init_validation_error_must_start_with() }
}

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("admin_screen_songs_item_title", CommonMainString0.admin_screen_songs_item_title)
  map.put("admin_screen_title", CommonMainString0.admin_screen_title)
  map.put("admin_screen_users_item_title", CommonMainString0.admin_screen_users_item_title)
  map.put("common_close_button", CommonMainString0.common_close_button)
  map.put("create_event_track_screen_add_button",
      CommonMainString0.create_event_track_screen_add_button)
  map.put("create_event_track_screen_additional",
      CommonMainString0.create_event_track_screen_additional)
  map.put("create_event_track_screen_artist", CommonMainString0.create_event_track_screen_artist)
  map.put("create_event_track_screen_comment", CommonMainString0.create_event_track_screen_comment)
  map.put("create_event_track_screen_members", CommonMainString0.create_event_track_screen_members)
  map.put("create_event_track_screen_select_track",
      CommonMainString0.create_event_track_screen_select_track)
  map.put("create_event_track_screen_title", CommonMainString0.create_event_track_screen_title)
  map.put("create_event_track_screen_track", CommonMainString0.create_event_track_screen_track)
  map.put("dialog_cancel", CommonMainString0.dialog_cancel)
  map.put("dialog_ok", CommonMainString0.dialog_ok)
  map.put("error_dialog_ok", CommonMainString0.error_dialog_ok)
  map.put("error_dialog_title", CommonMainString0.error_dialog_title)
  map.put("event_create_applies", CommonMainString0.event_create_applies)
  map.put("event_create_button", CommonMainString0.event_create_button)
  map.put("event_create_card_background", CommonMainString0.event_create_card_background)
  map.put("event_create_date", CommonMainString0.event_create_date)
  map.put("event_create_description", CommonMainString0.event_create_description)
  map.put("event_create_genre", CommonMainString0.event_create_genre)
  map.put("event_create_limits", CommonMainString0.event_create_limits)
  map.put("event_create_map_link", CommonMainString0.event_create_map_link)
  map.put("event_create_members", CommonMainString0.event_create_members)
  map.put("event_create_screen_title", CommonMainString0.event_create_screen_title)
  map.put("event_create_songs_count", CommonMainString0.event_create_songs_count)
  map.put("event_create_spot", CommonMainString0.event_create_spot)
  map.put("event_create_title", CommonMainString0.event_create_title)
  map.put("event_detail_confirm_member_cancellation_message",
      CommonMainString0.event_detail_confirm_member_cancellation_message)
  map.put("event_detail_confirm_member_cancellation_title",
      CommonMainString0.event_detail_confirm_member_cancellation_title)
  map.put("event_detail_confirm_member_message",
      CommonMainString0.event_detail_confirm_member_message)
  map.put("event_detail_confirm_member_title", CommonMainString0.event_detail_confirm_member_title)
  map.put("event_detail_screen_acceptance_optional",
      CommonMainString0.event_detail_screen_acceptance_optional)
  map.put("event_detail_screen_acceptance_title",
      CommonMainString0.event_detail_screen_acceptance_title)
  map.put("event_detail_screen_menu_edit", CommonMainString0.event_detail_screen_menu_edit)
  map.put("event_detail_screen_menu_set_list", CommonMainString0.event_detail_screen_menu_set_list)
  map.put("event_detail_screen_optional_warning",
      CommonMainString0.event_detail_screen_optional_warning)
  map.put("event_detail_screen_title", CommonMainString0.event_detail_screen_title)
  map.put("event_detail_screen_track_artist_and_track",
      CommonMainString0.event_detail_screen_track_artist_and_track)
  map.put("event_edit_screen_delete_button", CommonMainString0.event_edit_screen_delete_button)
  map.put("event_edit_screen_delete_confirmation_message",
      CommonMainString0.event_edit_screen_delete_confirmation_message)
  map.put("event_edit_screen_delete_confirmation_title",
      CommonMainString0.event_edit_screen_delete_confirmation_title)
  map.put("event_edit_screen_save_button", CommonMainString0.event_edit_screen_save_button)
  map.put("event_edit_screen_title", CommonMainString0.event_edit_screen_title)
  map.put("event_freeze_screen_backlog_header",
      CommonMainString0.event_freeze_screen_backlog_header)
  map.put("event_freeze_screen_frozen_hint", CommonMainString0.event_freeze_screen_frozen_hint)
  map.put("event_freeze_screen_save_button", CommonMainString0.event_freeze_screen_save_button)
  map.put("event_freeze_screen_switcher_label",
      CommonMainString0.event_freeze_screen_switcher_label)
  map.put("event_freeze_screen_title", CommonMainString0.event_freeze_screen_title)
  map.put("event_list_screen_title", CommonMainString0.event_list_screen_title)
  map.put("event_list_screen_tracks", CommonMainString0.event_list_screen_tracks)
  map.put("event_member_legend_not_required", CommonMainString0.event_member_legend_not_required)
  map.put("event_member_legend_optional", CommonMainString0.event_member_legend_optional)
  map.put("event_member_legend_required", CommonMainString0.event_member_legend_required)
  map.put("event_member_legend_title", CommonMainString0.event_member_legend_title)
  map.put("event_track_details_screen_added_by",
      CommonMainString0.event_track_details_screen_added_by)
  map.put("event_track_details_screen_backlog_header",
      CommonMainString0.event_track_details_screen_backlog_header)
  map.put("event_track_details_screen_delete_button",
      CommonMainString0.event_track_details_screen_delete_button)
  map.put("event_track_details_screen_delete_confirmation_message",
      CommonMainString0.event_track_details_screen_delete_confirmation_message)
  map.put("event_track_details_screen_delete_confirmation_title",
      CommonMainString0.event_track_details_screen_delete_confirmation_title)
  map.put("event_track_details_screen_ready_members",
      CommonMainString0.event_track_details_screen_ready_members)
  map.put("event_track_details_screen_required_members",
      CommonMainString0.event_track_details_screen_required_members)
  map.put("event_track_details_screen_title", CommonMainString0.event_track_details_screen_title)
  map.put("login_cannot_find_account", CommonMainString0.login_cannot_find_account)
  map.put("login_wanna_join", CommonMainString0.login_wanna_join)
  map.put("login_welcome_title", CommonMainString0.login_welcome_title)
  map.put("nav_bar_title_admin", CommonMainString0.nav_bar_title_admin)
  map.put("nav_bar_title_home", CommonMainString0.nav_bar_title_home)
  map.put("nav_bar_title_profile", CommonMainString0.nav_bar_title_profile)
  map.put("profile_admin_settings_button", CommonMainString0.profile_admin_settings_button)
  map.put("profile_city_placeholder", CommonMainString0.profile_city_placeholder)
  map.put("profile_edit", CommonMainString0.profile_edit)
  map.put("profile_logout_button", CommonMainString0.profile_logout_button)
  map.put("profile_name_placeholder", CommonMainString0.profile_name_placeholder)
  map.put("profile_save_button", CommonMainString0.profile_save_button)
  map.put("profile_screen_title", CommonMainString0.profile_screen_title)
  map.put("profile_telegram_placeholder", CommonMainString0.profile_telegram_placeholder)
  map.put("validation_error_date_before_now", CommonMainString0.validation_error_date_before_now)
  map.put("validation_error_empty_value", CommonMainString0.validation_error_empty_value)
  map.put("validation_error_invalid_date", CommonMainString0.validation_error_invalid_date)
  map.put("validation_error_invalid_digit", CommonMainString0.validation_error_invalid_digit)
  map.put("validation_error_invalid_symbol", CommonMainString0.validation_error_invalid_symbol)
  map.put("validation_error_item_not_selected",
      CommonMainString0.validation_error_item_not_selected)
  map.put("validation_error_items_max_selected",
      CommonMainString0.validation_error_items_max_selected)
  map.put("validation_error_max_int_value", CommonMainString0.validation_error_max_int_value)
  map.put("validation_error_max_length", CommonMainString0.validation_error_max_length)
  map.put("validation_error_min_int_value", CommonMainString0.validation_error_min_int_value)
  map.put("validation_error_must_start_with", CommonMainString0.validation_error_must_start_with)
}

internal val Res.string.admin_screen_songs_item_title: StringResource
  get() = CommonMainString0.admin_screen_songs_item_title

private fun init_admin_screen_songs_item_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:admin_screen_songs_item_title", "admin_screen_songs_item_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr", 10,
    45),
    )
)

internal val Res.string.admin_screen_title: StringResource
  get() = CommonMainString0.admin_screen_title

private fun init_admin_screen_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:admin_screen_title", "admin_screen_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr", 56,
    46),
    )
)

internal val Res.string.admin_screen_users_item_title: StringResource
  get() = CommonMainString0.admin_screen_users_item_title

private fun init_admin_screen_users_item_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:admin_screen_users_item_title", "admin_screen_users_item_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    103, 45),
    )
)

internal val Res.string.common_close_button: StringResource
  get() = CommonMainString0.common_close_button

private fun init_common_close_button(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:common_close_button", "common_close_button",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    149, 35),
    )
)

internal val Res.string.create_event_track_screen_add_button: StringResource
  get() = CommonMainString0.create_event_track_screen_add_button

private fun init_create_event_track_screen_add_button(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:create_event_track_screen_add_button", "create_event_track_screen_add_button",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    185, 48),
    )
)

internal val Res.string.create_event_track_screen_additional: StringResource
  get() = CommonMainString0.create_event_track_screen_additional

private fun init_create_event_track_screen_additional(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:create_event_track_screen_additional", "create_event_track_screen_additional",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    234, 60),
    )
)

internal val Res.string.create_event_track_screen_artist: StringResource
  get() = CommonMainString0.create_event_track_screen_artist

private fun init_create_event_track_screen_artist(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:create_event_track_screen_artist", "create_event_track_screen_artist",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    295, 56),
    )
)

internal val Res.string.create_event_track_screen_comment: StringResource
  get() = CommonMainString0.create_event_track_screen_comment

private fun init_create_event_track_screen_comment(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:create_event_track_screen_comment", "create_event_track_screen_comment",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    352, 53),
    )
)

internal val Res.string.create_event_track_screen_members: StringResource
  get() = CommonMainString0.create_event_track_screen_members

private fun init_create_event_track_screen_members(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:create_event_track_screen_members", "create_event_track_screen_members",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    406, 53),
    )
)

internal val Res.string.create_event_track_screen_select_track: StringResource
  get() = CommonMainString0.create_event_track_screen_select_track

private fun init_create_event_track_screen_select_track(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:create_event_track_screen_select_track", "create_event_track_screen_select_track",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    460, 62),
    )
)

internal val Res.string.create_event_track_screen_title: StringResource
  get() = CommonMainString0.create_event_track_screen_title

private fun init_create_event_track_screen_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:create_event_track_screen_title", "create_event_track_screen_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    523, 51),
    )
)

internal val Res.string.create_event_track_screen_track: StringResource
  get() = CommonMainString0.create_event_track_screen_track

private fun init_create_event_track_screen_track(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:create_event_track_screen_track", "create_event_track_screen_track",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    575, 55),
    )
)

internal val Res.string.dialog_cancel: StringResource
  get() = CommonMainString0.dialog_cancel

private fun init_dialog_cancel(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:dialog_cancel", "dialog_cancel",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    631, 29),
    )
)

internal val Res.string.dialog_ok: StringResource
  get() = CommonMainString0.dialog_ok

private fun init_dialog_ok(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:dialog_ok", "dialog_ok",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    661, 21),
    )
)

internal val Res.string.error_dialog_ok: StringResource
  get() = CommonMainString0.error_dialog_ok

private fun init_error_dialog_ok(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:error_dialog_ok", "error_dialog_ok",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    683, 27),
    )
)

internal val Res.string.error_dialog_title: StringResource
  get() = CommonMainString0.error_dialog_title

private fun init_error_dialog_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:error_dialog_title", "error_dialog_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    711, 34),
    )
)

internal val Res.string.event_create_applies: StringResource
  get() = CommonMainString0.event_create_applies

private fun init_event_create_applies(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_create_applies", "event_create_applies",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    746, 52),
    )
)

internal val Res.string.event_create_button: StringResource
  get() = CommonMainString0.event_create_button

private fun init_event_create_button(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_create_button", "event_create_button",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    799, 35),
    )
)

internal val Res.string.event_create_card_background: StringResource
  get() = CommonMainString0.event_create_card_background

private fun init_event_create_card_background(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_create_card_background", "event_create_card_background",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    835, 56),
    )
)

internal val Res.string.event_create_date: StringResource
  get() = CommonMainString0.event_create_date

private fun init_event_create_date(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_create_date", "event_create_date",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    892, 33),
    )
)

internal val Res.string.event_create_description: StringResource
  get() = CommonMainString0.event_create_description

private fun init_event_create_description(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_create_description", "event_create_description",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    926, 48),
    )
)

internal val Res.string.event_create_genre: StringResource
  get() = CommonMainString0.event_create_genre

private fun init_event_create_genre(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_create_genre", "event_create_genre",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    975, 34),
    )
)

internal val Res.string.event_create_limits: StringResource
  get() = CommonMainString0.event_create_limits

private fun init_event_create_limits(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_create_limits", "event_create_limits",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    1010, 35),
    )
)

internal val Res.string.event_create_map_link: StringResource
  get() = CommonMainString0.event_create_map_link

private fun init_event_create_map_link(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_create_map_link", "event_create_map_link",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    1046, 41),
    )
)

internal val Res.string.event_create_members: StringResource
  get() = CommonMainString0.event_create_members

private fun init_event_create_members(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_create_members", "event_create_members",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    1088, 40),
    )
)

internal val Res.string.event_create_screen_title: StringResource
  get() = CommonMainString0.event_create_screen_title

private fun init_event_create_screen_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_create_screen_title", "event_create_screen_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    1129, 49),
    )
)

internal val Res.string.event_create_songs_count: StringResource
  get() = CommonMainString0.event_create_songs_count

private fun init_event_create_songs_count(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_create_songs_count", "event_create_songs_count",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    1179, 40),
    )
)

internal val Res.string.event_create_spot: StringResource
  get() = CommonMainString0.event_create_spot

private fun init_event_create_spot(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_create_spot", "event_create_spot",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    1220, 33),
    )
)

internal val Res.string.event_create_title: StringResource
  get() = CommonMainString0.event_create_title

private fun init_event_create_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_create_title", "event_create_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    1254, 34),
    )
)

internal val Res.string.event_detail_confirm_member_cancellation_message: StringResource
  get() = CommonMainString0.event_detail_confirm_member_cancellation_message

private fun init_event_detail_confirm_member_cancellation_message(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_detail_confirm_member_cancellation_message",
    "event_detail_confirm_member_cancellation_message",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    1289, 128),
    )
)

internal val Res.string.event_detail_confirm_member_cancellation_title: StringResource
  get() = CommonMainString0.event_detail_confirm_member_cancellation_title

private fun init_event_detail_confirm_member_cancellation_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_detail_confirm_member_cancellation_title",
    "event_detail_confirm_member_cancellation_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    1418, 82),
    )
)

internal val Res.string.event_detail_confirm_member_message: StringResource
  get() = CommonMainString0.event_detail_confirm_member_message

private fun init_event_detail_confirm_member_message(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_detail_confirm_member_message", "event_detail_confirm_member_message",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    1501, 111),
    )
)

internal val Res.string.event_detail_confirm_member_title: StringResource
  get() = CommonMainString0.event_detail_confirm_member_title

private fun init_event_detail_confirm_member_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_detail_confirm_member_title", "event_detail_confirm_member_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    1613, 65),
    )
)

internal val Res.string.event_detail_screen_acceptance_optional: StringResource
  get() = CommonMainString0.event_detail_screen_acceptance_optional

private fun init_event_detail_screen_acceptance_optional(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_detail_screen_acceptance_optional", "event_detail_screen_acceptance_optional",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    1679, 67),
    )
)

internal val Res.string.event_detail_screen_acceptance_title: StringResource
  get() = CommonMainString0.event_detail_screen_acceptance_title

private fun init_event_detail_screen_acceptance_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_detail_screen_acceptance_title", "event_detail_screen_acceptance_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    1747, 84),
    )
)

internal val Res.string.event_detail_screen_menu_edit: StringResource
  get() = CommonMainString0.event_detail_screen_menu_edit

private fun init_event_detail_screen_menu_edit(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_detail_screen_menu_edit", "event_detail_screen_menu_edit",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    1832, 45),
    )
)

internal val Res.string.event_detail_screen_menu_set_list: StringResource
  get() = CommonMainString0.event_detail_screen_menu_set_list

private fun init_event_detail_screen_menu_set_list(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_detail_screen_menu_set_list", "event_detail_screen_menu_set_list",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    1878, 53),
    )
)

internal val Res.string.event_detail_screen_optional_warning: StringResource
  get() = CommonMainString0.event_detail_screen_optional_warning

private fun init_event_detail_screen_optional_warning(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_detail_screen_optional_warning", "event_detail_screen_optional_warning",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    1932, 152),
    )
)

internal val Res.string.event_detail_screen_title: StringResource
  get() = CommonMainString0.event_detail_screen_title

private fun init_event_detail_screen_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_detail_screen_title", "event_detail_screen_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    2085, 53),
    )
)

internal val Res.string.event_detail_screen_track_artist_and_track: StringResource
  get() = CommonMainString0.event_detail_screen_track_artist_and_track

private fun init_event_detail_screen_track_artist_and_track(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_detail_screen_track_artist_and_track", "event_detail_screen_track_artist_and_track",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    2139, 66),
    )
)

internal val Res.string.event_edit_screen_delete_button: StringResource
  get() = CommonMainString0.event_edit_screen_delete_button

private fun init_event_edit_screen_delete_button(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_edit_screen_delete_button", "event_edit_screen_delete_button",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    2206, 55),
    )
)

internal val Res.string.event_edit_screen_delete_confirmation_message: StringResource
  get() = CommonMainString0.event_edit_screen_delete_confirmation_message

private fun init_event_edit_screen_delete_confirmation_message(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_edit_screen_delete_confirmation_message",
    "event_edit_screen_delete_confirmation_message",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    2262, 105),
    )
)

internal val Res.string.event_edit_screen_delete_confirmation_title: StringResource
  get() = CommonMainString0.event_edit_screen_delete_confirmation_title

private fun init_event_edit_screen_delete_confirmation_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_edit_screen_delete_confirmation_title",
    "event_edit_screen_delete_confirmation_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    2368, 67),
    )
)

internal val Res.string.event_edit_screen_save_button: StringResource
  get() = CommonMainString0.event_edit_screen_save_button

private fun init_event_edit_screen_save_button(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_edit_screen_save_button", "event_edit_screen_save_button",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    2436, 45),
    )
)

internal val Res.string.event_edit_screen_title: StringResource
  get() = CommonMainString0.event_edit_screen_title

private fun init_event_edit_screen_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_edit_screen_title", "event_edit_screen_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    2482, 47),
    )
)

internal val Res.string.event_freeze_screen_backlog_header: StringResource
  get() = CommonMainString0.event_freeze_screen_backlog_header

private fun init_event_freeze_screen_backlog_header(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_freeze_screen_backlog_header", "event_freeze_screen_backlog_header",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    2530, 54),
    )
)

internal val Res.string.event_freeze_screen_frozen_hint: StringResource
  get() = CommonMainString0.event_freeze_screen_frozen_hint

private fun init_event_freeze_screen_frozen_hint(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_freeze_screen_frozen_hint", "event_freeze_screen_frozen_hint",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    2585, 111),
    )
)

internal val Res.string.event_freeze_screen_save_button: StringResource
  get() = CommonMainString0.event_freeze_screen_save_button

private fun init_event_freeze_screen_save_button(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_freeze_screen_save_button", "event_freeze_screen_save_button",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    2697, 47),
    )
)

internal val Res.string.event_freeze_screen_switcher_label: StringResource
  get() = CommonMainString0.event_freeze_screen_switcher_label

private fun init_event_freeze_screen_switcher_label(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_freeze_screen_switcher_label", "event_freeze_screen_switcher_label",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    2745, 58),
    )
)

internal val Res.string.event_freeze_screen_title: StringResource
  get() = CommonMainString0.event_freeze_screen_title

private fun init_event_freeze_screen_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_freeze_screen_title", "event_freeze_screen_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    2804, 49),
    )
)

internal val Res.string.event_list_screen_title: StringResource
  get() = CommonMainString0.event_list_screen_title

private fun init_event_list_screen_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_list_screen_title", "event_list_screen_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    2854, 47),
    )
)

internal val Res.string.event_list_screen_tracks: StringResource
  get() = CommonMainString0.event_list_screen_tracks

private fun init_event_list_screen_tracks(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_list_screen_tracks", "event_list_screen_tracks",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    2902, 56),
    )
)

internal val Res.string.event_member_legend_not_required: StringResource
  get() = CommonMainString0.event_member_legend_not_required

private fun init_event_member_legend_not_required(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_member_legend_not_required", "event_member_legend_not_required",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    2959, 60),
    )
)

internal val Res.string.event_member_legend_optional: StringResource
  get() = CommonMainString0.event_member_legend_optional

private fun init_event_member_legend_optional(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_member_legend_optional", "event_member_legend_optional",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    3020, 132),
    )
)

internal val Res.string.event_member_legend_required: StringResource
  get() = CommonMainString0.event_member_legend_required

private fun init_event_member_legend_required(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_member_legend_required", "event_member_legend_required",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    3153, 72),
    )
)

internal val Res.string.event_member_legend_title: StringResource
  get() = CommonMainString0.event_member_legend_title

private fun init_event_member_legend_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_member_legend_title", "event_member_legend_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    3226, 41),
    )
)

internal val Res.string.event_track_details_screen_added_by: StringResource
  get() = CommonMainString0.event_track_details_screen_added_by

private fun init_event_track_details_screen_added_by(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_track_details_screen_added_by", "event_track_details_screen_added_by",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    3268, 55),
    )
)

internal val Res.string.event_track_details_screen_backlog_header: StringResource
  get() = CommonMainString0.event_track_details_screen_backlog_header

private fun init_event_track_details_screen_backlog_header(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_track_details_screen_backlog_header", "event_track_details_screen_backlog_header",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    3324, 61),
    )
)

internal val Res.string.event_track_details_screen_delete_button: StringResource
  get() = CommonMainString0.event_track_details_screen_delete_button

private fun init_event_track_details_screen_delete_button(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_track_details_screen_delete_button", "event_track_details_screen_delete_button",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    3386, 64),
    )
)

internal val Res.string.event_track_details_screen_delete_confirmation_message: StringResource
  get() = CommonMainString0.event_track_details_screen_delete_confirmation_message

private fun init_event_track_details_screen_delete_confirmation_message(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_track_details_screen_delete_confirmation_message",
    "event_track_details_screen_delete_confirmation_message",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    3451, 114),
    )
)

internal val Res.string.event_track_details_screen_delete_confirmation_title: StringResource
  get() = CommonMainString0.event_track_details_screen_delete_confirmation_title

private fun init_event_track_details_screen_delete_confirmation_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_track_details_screen_delete_confirmation_title",
    "event_track_details_screen_delete_confirmation_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    3566, 76),
    )
)

internal val Res.string.event_track_details_screen_ready_members: StringResource
  get() = CommonMainString0.event_track_details_screen_ready_members

private fun init_event_track_details_screen_ready_members(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_track_details_screen_ready_members", "event_track_details_screen_ready_members",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    3643, 56),
    )
)

internal val Res.string.event_track_details_screen_required_members: StringResource
  get() = CommonMainString0.event_track_details_screen_required_members

private fun init_event_track_details_screen_required_members(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_track_details_screen_required_members",
    "event_track_details_screen_required_members",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    3700, 63),
    )
)

internal val Res.string.event_track_details_screen_title: StringResource
  get() = CommonMainString0.event_track_details_screen_title

private fun init_event_track_details_screen_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:event_track_details_screen_title", "event_track_details_screen_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    3764, 60),
    )
)

internal val Res.string.login_cannot_find_account: StringResource
  get() = CommonMainString0.login_cannot_find_account

private fun init_login_cannot_find_account(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:login_cannot_find_account", "login_cannot_find_account",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    3825, 85),
    )
)

internal val Res.string.login_wanna_join: StringResource
  get() = CommonMainString0.login_wanna_join

private fun init_login_wanna_join(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:login_wanna_join", "login_wanna_join",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    3911, 40),
    )
)

internal val Res.string.login_welcome_title: StringResource
  get() = CommonMainString0.login_welcome_title

private fun init_login_welcome_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:login_welcome_title", "login_welcome_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    3952, 43),
    )
)

internal val Res.string.nav_bar_title_admin: StringResource
  get() = CommonMainString0.nav_bar_title_admin

private fun init_nav_bar_title_admin(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:nav_bar_title_admin", "nav_bar_title_admin",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    3996, 35),
    )
)

internal val Res.string.nav_bar_title_home: StringResource
  get() = CommonMainString0.nav_bar_title_home

private fun init_nav_bar_title_home(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:nav_bar_title_home", "nav_bar_title_home",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    4032, 34),
    )
)

internal val Res.string.nav_bar_title_profile: StringResource
  get() = CommonMainString0.nav_bar_title_profile

private fun init_nav_bar_title_profile(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:nav_bar_title_profile", "nav_bar_title_profile",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    4067, 41),
    )
)

internal val Res.string.profile_admin_settings_button: StringResource
  get() = CommonMainString0.profile_admin_settings_button

private fun init_profile_admin_settings_button(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:profile_admin_settings_button", "profile_admin_settings_button",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    4109, 57),
    )
)

internal val Res.string.profile_city_placeholder: StringResource
  get() = CommonMainString0.profile_city_placeholder

private fun init_profile_city_placeholder(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:profile_city_placeholder", "profile_city_placeholder",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    4167, 40),
    )
)

internal val Res.string.profile_edit: StringResource
  get() = CommonMainString0.profile_edit

private fun init_profile_edit(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:profile_edit", "profile_edit",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    4208, 28),
    )
)

internal val Res.string.profile_logout_button: StringResource
  get() = CommonMainString0.profile_logout_button

private fun init_profile_logout_button(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:profile_logout_button", "profile_logout_button",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    4237, 41),
    )
)

internal val Res.string.profile_name_placeholder: StringResource
  get() = CommonMainString0.profile_name_placeholder

private fun init_profile_name_placeholder(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:profile_name_placeholder", "profile_name_placeholder",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    4279, 40),
    )
)

internal val Res.string.profile_save_button: StringResource
  get() = CommonMainString0.profile_save_button

private fun init_profile_save_button(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:profile_save_button", "profile_save_button",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    4320, 35),
    )
)

internal val Res.string.profile_screen_title: StringResource
  get() = CommonMainString0.profile_screen_title

private fun init_profile_screen_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:profile_screen_title", "profile_screen_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    4356, 40),
    )
)

internal val Res.string.profile_telegram_placeholder: StringResource
  get() = CommonMainString0.profile_telegram_placeholder

private fun init_profile_telegram_placeholder(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:profile_telegram_placeholder", "profile_telegram_placeholder",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    4397, 48),
    )
)

internal val Res.string.validation_error_date_before_now: StringResource
  get() = CommonMainString0.validation_error_date_before_now

private fun init_validation_error_date_before_now(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:validation_error_date_before_now", "validation_error_date_before_now",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    4446, 80),
    )
)

internal val Res.string.validation_error_empty_value: StringResource
  get() = CommonMainString0.validation_error_empty_value

private fun init_validation_error_empty_value(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:validation_error_empty_value", "validation_error_empty_value",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    4527, 56),
    )
)

internal val Res.string.validation_error_invalid_date: StringResource
  get() = CommonMainString0.validation_error_invalid_date

private fun init_validation_error_invalid_date(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:validation_error_invalid_date", "validation_error_invalid_date",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    4584, 65),
    )
)

internal val Res.string.validation_error_invalid_digit: StringResource
  get() = CommonMainString0.validation_error_invalid_digit

private fun init_validation_error_invalid_digit(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:validation_error_invalid_digit", "validation_error_invalid_digit",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    4650, 66),
    )
)

internal val Res.string.validation_error_invalid_symbol: StringResource
  get() = CommonMainString0.validation_error_invalid_symbol

private fun init_validation_error_invalid_symbol(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:validation_error_invalid_symbol", "validation_error_invalid_symbol",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    4717, 59),
    )
)

internal val Res.string.validation_error_item_not_selected: StringResource
  get() = CommonMainString0.validation_error_item_not_selected

private fun init_validation_error_item_not_selected(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:validation_error_item_not_selected", "validation_error_item_not_selected",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    4777, 78),
    )
)

internal val Res.string.validation_error_items_max_selected: StringResource
  get() = CommonMainString0.validation_error_items_max_selected

private fun init_validation_error_items_max_selected(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:validation_error_items_max_selected", "validation_error_items_max_selected",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    4856, 95),
    )
)

internal val Res.string.validation_error_max_int_value: StringResource
  get() = CommonMainString0.validation_error_max_int_value

private fun init_validation_error_max_int_value(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:validation_error_max_int_value", "validation_error_max_int_value",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    4952, 62),
    )
)

internal val Res.string.validation_error_max_length: StringResource
  get() = CommonMainString0.validation_error_max_length

private fun init_validation_error_max_length(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:validation_error_max_length", "validation_error_max_length",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    5015, 83),
    )
)

internal val Res.string.validation_error_min_int_value: StringResource
  get() = CommonMainString0.validation_error_min_int_value

private fun init_validation_error_min_int_value(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:validation_error_min_int_value", "validation_error_min_int_value",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    5099, 62),
    )
)

internal val Res.string.validation_error_must_start_with: StringResource
  get() = CommonMainString0.validation_error_must_start_with

private fun init_validation_error_must_start_with(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:validation_error_must_start_with", "validation_error_must_start_with",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/limasoul.client.shared.generated.resources/values/strings.commonMain.cvr",
    5162, 72),
    )
)
